import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c667749"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkModal" }
const _hoisted_2 = { class: "OkModal__container" }
const _hoisted_3 = { class: "container__header" }
const _hoisted_4 = { class: "header__title" }
const _hoisted_5 = { class: "container__body" }
const _hoisted_6 = { class: "container__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ok_button = _resolveComponent("ok-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createElementVNode("i", {
          class: "fas fa-times cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ok_button, {
          disabled: _ctx.disabled,
          loading: _ctx.loading,
          type: "button",
          class: "OkButton--blue",
          onClick: _ctx.onConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.confirmButtonText), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"]),
        _createVNode(_component_ok_button, {
          disabled: _ctx.disabled,
          loading: _ctx.loading,
          type: "button",
          class: "OkButton--outline OkButton--blue",
          onClick: _ctx.onCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.cancelButtonText), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ])
    ])
  ]))
}